import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function showStudentSchedule(): Promise<ApiResponse> {
  return Axios.get("v1/students/schedules");
}
export function indexStudentSchedules(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get("/v1/students/schedules", { params });
}
export function indexStudentFormatSchedules(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get("v1/students/schedules/show_formatted_schedule", { params });
}
export function indexStudentFormatSchedulesDateRange(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get("v2/students/schedules", { params });
}
export function indexTutorStudentSchedules(): Promise<ApiResponse> {
  return Axios.get("/v1/students/schedule_slots");
}
export function indexNewStudentAvailableSchedules(
  telawahId: string | number,
  slotData: object,
  tutorId?: string | number
): Promise<ApiResponse> {
  const params: { telawah_id: string | number; tutor_id?: string | number } = {
    telawah_id: telawahId,
  };
  if (!!tutorId) {
    params["tutor_id"] = tutorId;
  }
  return Axios.post(`v1/students/schedules/tutors_availability`, slotData, {
    params,
  });
}
export function createSchedulesStudent(data: object): Promise<ApiResponse> {
  return Axios.post(`v1/students/schedules`, data);
}
